/**
 * @generated SignedSource<<59fa67c1551da6e99a9aa17cb761886b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftDraftItemTileDetails_nftItemDraft$data = {
  readonly createdDate: string | null;
  readonly editionNumber: number | null;
  readonly editionTotal: number | null;
  readonly modifiedDate: string | null;
  readonly name: string | null;
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"NftItemTileTooltip_nftItemDraft">;
  readonly " $fragmentType": "NftDraftItemTileDetails_nftItemDraft";
};
export type NftDraftItemTileDetails_nftItemDraft$key = {
  readonly " $data"?: NftDraftItemTileDetails_nftItemDraft$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftDraftItemTileDetails_nftItemDraft">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftDraftItemTileDetails_nftItemDraft",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "editionNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "editionTotal",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "modifiedDate",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftItemTileTooltip_nftItemDraft"
    }
  ],
  "type": "NftItemDraft",
  "abstractKey": null
};

(node as any).hash = "ee5143a9968a2a27e0ee26fb662df72a";

export default node;
